import React, { useState } from "react";
import styled from "styled-components";
import fipayFonts from "../../theme/index";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  @media only screen and (max-width: 767px) {
    width: 90%;
  }
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
  @media only screen and (max-width: 767px) {
    width: 90%;
  }
`;
const ModalP = styled.p`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  font-family: GT Walsheim Pro;
  line-height: 24px;
  font-size: ${fipayFonts.fipayFonts.fontSize.body1};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  padding: 10px 10px;
  border-radius: 12px 12px 0px 0px;
  background-color: #ceccde;
`;
const ShareLinkContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;
const SocialMedial01 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  margin-bottom: 20px;
`;
const SocialMedial02 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  margin-bottom: 20px;
`;
const ShareButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ShareModal = ({
  isOpen,
  onClose,
  linkToCopy,
}: {
  isOpen: boolean;
  onClose: () => void;
  linkToCopy: string;
}) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(linkToCopy);
    setIsCopied(true);
  };

  const handleShare = (platform: string) => {
    switch (platform) {
      case "email":
        const emailSubject = "Check out this payment link!";
        const emailBody = `Click on the link to view the payment details: ${linkToCopy}`;
        window.location.href = `mailto:?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
        break;
      case "facebook":
        window.open("https://www.facebook.com/");
        break;
      case "whatsapp":
        window.open("https://web.whatsapp.com/");
        break;
      case "telegram":
        window.open("https://web.telegram.com/");
        break;
      case "twitter":
        window.open("https://web.twitter.com/");
        break;
      case "instagram":
        window.open("https://www.instagram.com/");
        break;

      default:
        break;
    }

    onClose();
  };
  const handleCancel = () => {
    onClose();
  };
  return (
    <>
      {isOpen && (
        <ModalOverlay>
          <ModalContent>
            <ModalP
              style={{
                padding: "10px 10px",
                borderRadius: "12px 12px 0px 0px",
                backgroundColor: "#ceccde",
                border: "1px solid #ccc",
                cursor: "pointer",
              }}
            >
              Share Link
            </ModalP>

            <ShareButtonsContainer>
              <SocialMedial01>
                <img
                  onClick={() => handleShare("email")}
                  src="/assets/icons/gmail.png"
                  alt="email"
                  width="30"
                  height="30"
                />
                <img
                  onClick={() => handleShare("facebook")}
                  src="/assets/icons/facebook.png"
                  alt="facebook"
                  width="30"
                  height="30"
                />
                <img
                  onClick={() => handleShare("whatsapp")}
                  src="/assets/icons/whatsapp01.jpeg"
                  alt="whatsapp"
                  width="30"
                  height="30"
                />
              </SocialMedial01>
              <SocialMedial02>
                <img
                  onClick={() => handleShare("instagram")}
                  src="/assets/icons/instagram.png"
                  alt="instagram"
                  width="30"
                  height="30"
                />
                <img
                  onClick={() => handleShare("telegram")}
                  src="/assets/icons/telegram01.jpeg"
                  alt="telegram"
                  width="30"
                  height="30"
                />
                <img
                  onClick={() => handleShare("twitter")}
                  src="/assets/icons/x01.png"
                  alt="twitter"
                  width="30"
                  height="30"
                />
              </SocialMedial02>
            </ShareButtonsContainer>
            <ShareLinkContainer>
              <button
                onClick={handleCancel}
                style={{
                  background: "#f0f0f0",
                  border: "1px solid #ccc",
                  color: "#333",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>

              <button
                onClick={handleCopyLink}
                disabled={isCopied}
                style={{
                  background: "#00a603",
                  color: "#fff",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                {isCopied ? "Link Copied!" : "Copy Link"}
              </button>
            </ShareLinkContainer>
          </ModalContent>
        </ModalOverlay>
      )}
    </>
  );
};

export default ShareModal;
